var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.75 1.75h-4.5a.5.5 0 0 0 0 1h1.511l-2.6 6.5H2.25a.5.5 0 0 0 0 1h4.5a.5.5 0 1 0 0-1H5.239l2.6-6.5H9.75a.5.5 0 0 0 0-1",
    clipRule: "evenodd"
  })));
});
const SvgTextEditItalicsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextEditItalicsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljc1IDEuNzUwMTNINy41MTE2NUM3LjUwMzk3IDEuNzQ5OTYgNy40OTYzMSAxLjc0OTk2IDcuNDg4NjYgMS43NTAxM0g1LjI1QzQuOTczODYgMS43NTAxMyA0Ljc1IDEuOTczOTkgNC43NSAyLjI1MDEzQzQuNzUgMi41MjYyOCA0Ljk3Mzg2IDIuNzUwMTMgNS4yNSAyLjc1MDEzSDYuNzYxNDhMNC4xNjE0OCA5LjI1MDEzSDIuMjVDMS45NzM4NiA5LjI1MDEzIDEuNzUgOS40NzM5OSAxLjc1IDkuNzUwMTNDMS43NSAxMC4wMjYzIDEuOTczODYgMTAuMjUwMSAyLjI1IDEwLjI1MDFINC40ODgzN0M0LjQ5NjA0IDEwLjI1MDMgNC41MDM2OSAxMC4yNTAzIDQuNTExMzIgMTAuMjUwMUg2Ljc1QzcuMDI2MTQgMTAuMjUwMSA3LjI1IDEwLjAyNjMgNy4yNSA5Ljc1MDEzQzcuMjUgOS40NzM5OSA3LjAyNjE0IDkuMjUwMTMgNi43NSA5LjI1MDEzSDUuMjM4NTJMNy44Mzg1MiAyLjc1MDEzSDkuNzVDMTAuMDI2MSAyLjc1MDEzIDEwLjI1IDIuNTI2MjggMTAuMjUgMi4yNTAxM0MxMC4yNSAxLjk3Mzk5IDEwLjAyNjEgMS43NTAxMyA5Ljc1IDEuNzUwMTNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";